import { render, staticRenderFns } from "./CreatePart4.vue?vue&type=template&id=4a537820&"
import script from "./CreatePart4.vue?vue&type=script&lang=js&"
export * from "./CreatePart4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports